
export function isValidJSON(value) {
    try {
        let isJSON = false;

        if (value && /^[\],:{}\s]*$/.test(value.replace(/\\["\\\/bfnrtu]/g, '@').
            replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
            replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
            isJSON = true
        }
        return isJSON;
    } catch (error) {
        return false;
    }
};
